import type { IconNode } from '../types';

/**
 * @name circle-letter-b
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOSAxMmg0Ljg0NmEyLjI0IDIuMjQgMCAwMTEuNTIzLjU4NiAyIDIgMCAwMS4wMDEgMi44MjggMi4yNCAyLjI0IDAgMDEtMS41MjQuNTg2SDkuNWEuNS41IDAgMDEtLjUtLjV2LTdhLjUuNSAwIDAxLjUtLjVIMTNhMiAyIDAgMDEwIDQiIC8+CiAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTAiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/circle-letter-b
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const CircleLetterB: IconNode = [
  [
    'path',
    {
      d: 'M9 12h4.846a2.24 2.24 0 011.523.586 2 2 0 01.001 2.828 2.24 2.24 0 01-1.524.586H9.5a.5.5 0 01-.5-.5v-7a.5.5 0 01.5-.5H13a2 2 0 010 4',
    },
  ],
  ['circle', { cx: '12', cy: '12', r: '10' }],
];

export default CircleLetterB;
